import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";

const Hero = () => {
  const heroStyle = {
    backgroundColor: "#f2faf5", // A very soft, modern light green
    minHeight: "90vh",
    display: "flex",
    alignItems: "center",
    paddingTop: "80px", // Adjust for fixed navbar
  };

  return (
    <section id="home" style={heroStyle}>
      <Container>
        <Row className="align-items-center">
          <Col lg={7} className="py-5">
            <h6
              className="text-success fw-bold text-uppercase mb-3"
              style={{ letterSpacing: "2px" }}
            >
              Welcome to Viriya
            </h6>
            <h1 className="display-4 fw-bold text-dark mb-4">
              International Education for{" "}
              <span className="text-success">Foundation Level</span> to IGCSE
              and GED
            </h1>
            <p className="lead text-muted mb-4 border-start border-success border-4 ps-3 italic">
              “Viriya International School provides flexible, quality
              international education for students from Kindergarten to
              Pre-University level.”
            </p>

            <div className="d-flex flex-wrap gap-3 mb-5">
              <div className="bg-white p-3 rounded shadow-sm d-flex align-items-center">
                <span className="fs-3 me-2">💻</span>
                <div>
                  <div className="fw-bold small">Online</div>
                  <div className="text-muted smaller">Learning</div>
                </div>
              </div>
              <div className="bg-white p-3 rounded shadow-sm d-flex align-items-center">
                <span className="fs-3 me-2">🏫</span>
                <div>
                  <div className="fw-bold small">On-Campus</div>
                  <div className="text-muted smaller">Learning</div>
                </div>
              </div>
            </div>

            <Button
              variant="success"
              size="lg"
              href="#admission"
              className="px-4 py-2 shadow-sm"
            >
              Start Application
            </Button>
          </Col>

          <Col lg={5} className="d-none d-lg-block">
            {/* You can replace this with an actual image of your school */}
            <div className="position-relative">
              <img
                src="https://images.unsplash.com/photo-1546410531-bb4caa6b424d?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80"
                alt="Students learning"
                className="img-fluid rounded shadow-lg position-relative"
                style={{ zIndex: 1 }}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Hero;
